import React, { useRef, useState, useEffect } from "react"
import "../assets/css/Map.css";
import "../assets/css/Popup.css";
import MapContext from "./MapContext";
import * as ol from "ol";
import Overlay from 'ol/Overlay';
import CloseIcon from '@mui/icons-material/Close';
import RechercheLocalisation from "../composants/RechercheLocalisation";
import PopupVisualisation from "../PopupVisualisation";
import GestionAffichageCouches from "../composants/GestionAffichageCouches";

const Map = ({ children, zoom, center, setCenter ,setCentreAdresse}) => {
	const mapRef = useRef();
	const [map, setMap] = useState(null);
	const [pointsurvolle, setPointSurvolle] = useState(null);
	const mousein = useRef(false);



	// on component mount
	useEffect(() => {

		var overlayvisualisation = new Overlay({
			element: document.querySelector(`#popup-ajout`),
			autoPan: true,
			positioning: 'top-center',
			autoPanAnimation: {
				duration: 250,
			},
		});

		let options = {
			view: new ol.View({ zoom, center }),
			layers: [],
			controls: [],
			overlays: [overlayvisualisation]
		};

		let mapObject = new ol.Map(options);
		mapObject.setTarget(mapRef.current);

		var closer = document.querySelector(`#popup-closer-ajout`)
		if (closer)
			closer.onclick = function () {
				overlayvisualisation.setPosition(undefined);
				closer.blur();
				return false;
			};


		mapObject.on('singleclick', function (evt) {
			if (!mousein.current) {
				var points = mapObject.getFeaturesAtPixel(evt.pixel, { hitTolerance: 1 });
				if(points.length===0){
					overlayvisualisation.setPosition(null)
				}
				points.forEach(couche => {
					setPointSurvolle(couche.getProperties());
					console.log(couche.getGeometry().getCoordinates())
					overlayvisualisation.setPosition(evt.coordinate);
				})
			}
		});

		setMap(mapObject);
		return () => mapObject.setTarget(undefined);
		// eslint-disable-next-line
	}, []);


	// zoom change handler
	useEffect(() => {
		if (!map) return;

		map.getView().setZoom(zoom);
		// eslint-disable-next-line
	}, [zoom]);

	// center change handler
	useEffect(() => {
		if (!map) return;

		map.getView().setCenter(center)
		// eslint-disable-next-line
	}, [center])


	return (
		<MapContext.Provider value={{ map }}>
			<RechercheLocalisation map={map} center={center} setCenter={setCenter} setCentreAdresse={setCentreAdresse}/>
			<div ref={mapRef} className="ol-map">
				{children}
			</div>
			<div id="popup-ajout" className="ol-popup">
				<a href="/#" id="popup-closer-ajout" className="ol-popup-closer-ajout"><CloseIcon className="bouttonfermer"></CloseIcon></a>
				<PopupVisualisation pointsurvolle={pointsurvolle} />
			</div>
			<GestionAffichageCouches />
		</MapContext.Provider>
	)
}

export default Map;